namespace GeniuzPOS.QRreport {
    export interface QHourTimeRow {
        Id?: number;
        HourTime?: number;
        HourTimeName?: string;
        HourTimeNameEn?: string;
    }

    export namespace QHourTimeRow {
        export const idProperty = 'HourTime';
        export const nameProperty = 'HourTimeName';
        export const localTextPrefix = 'QRreport.QHourTime';
        export const lookupKey = 'QRreport.QHourTime';

        export function getLookup(): Q.Lookup<QHourTimeRow> {
            return Q.getLookup<QHourTimeRow>('QRreport.QHourTime');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            HourTime = "HourTime",
            HourTimeName = "HourTimeName",
            HourTimeNameEn = "HourTimeNameEn"
        }
    }
}
